import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router'; // eslint-disable-line

import { NAV_DATA } from 'constants/navConstants';
import SecondaryNavV2 from 'components/common/header/SecondaryNavV2';

import { grabGuestByUuid, getGuestRequests } from '../../../../actions/PublicWebsiteActions';
/* css imports */
import './TrackRsvpNotifications.less';
import featureFlags from '../../../../util/featureFlags';

const navRedesign = featureFlags.get('navRedesign');

class MultipleRsvpNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.onStoreNotificationObject = this.onStoreNotificationObject.bind(this);
  }

  componentWillMount() {
    const { onGetGuestRequests } = this.props;
    onGetGuestRequests();
  }

  onStoreNotificationObject(notification) {
    const { grabGuest } = this.props;
    grabGuest(notification.uuid);
  }

  render() {
    const { guestRequestNotifications } = this.props;
    const allNotifications = [];
    guestRequestNotifications.forEach((notification, idx) => {
      allNotifications.push(
        (
          <li key={idx} className="guest-row" onClick={() => this.onStoreNotificationObject(notification)}>
            <Link to={`/wedding/manage/guests/rsvp-notification/${notification.uuid}`}>
              <p className="guest-names">{notification.first_name} {notification.family_name}<span className="notification-caret" />
              </p>
            </Link>
          </li>
        )
      );
    });

    return (
      <div id="rsvp-notifications">
        {navRedesign &&  <SecondaryNavV2 activeLinkId={NAV_DATA.SECONDARY.GUEST_LIST.RSVP_REQUESTS} />}
        <div className="rsvp-notifications-container">
          <div className="body">
            <div className="rsvp-card" />
            <h1>{allNotifications.length} Guest{allNotifications.length > 1 ? 's' : ''} {allNotifications.length > 1 ? 'Are' : 'Is'} Requesting RSVP Access</h1>
            <div className="request-container">
              <ul className="list-unstyled guest-requests">
                {allNotifications}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MultipleRsvpNotifications.propTypes = {
  guestRequestNotifications: PropTypes.arrayOf(PropTypes.shape({})),
  // notificationObject: PropTypes.shape({}),
  onGetGuestRequests: PropTypes.func,
  // guestRequestCount: PropTypes.number
  // onStoreNotificationObject: PropTypes.func
  grabGuest: PropTypes.func
};

const mapStateToProps = state => (
  {
    guestRequestNotifications: state.publicWebsite.guestRequestObject,
    addGuestPage: state.publicWebsite.addGuestPage,
    notificationObject: state.publicWebsite.guestRequestByUuid,
    guestRequestCount: state.publicWebsite.guestRequestCount,
  }
);

const mapDispatchToProps = dispatch => (
  {
    grabGuest: guestUuid => dispatch(grabGuestByUuid(guestUuid)),
    onGetGuestRequests: () => dispatch(getGuestRequests())
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultipleRsvpNotifications);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/trackRsvpNotifications/MultipleRsvpNotifications.jsx